import { BusinessProtectionProductsInput } from '../generated/resolvers'
import request from '../requesters/default'
import { setVerificationCacheInvalidation } from '../utils'

export const saveBusinessProtectionProducts = async (body: BusinessProtectionProductsInput) => {
  const response = await request.post('/protection_solution', body)

  // Set BE verification cache invalidation flag
  setVerificationCacheInvalidation()

  return response?.data?.protection_products
}
